import { UsersList } from '@openx/components-administration/lib/UsersList/UsersList.tsx';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton.tsx';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useTranslation } from 'react-i18next';
import { useGetUsersDataAndCriteria } from './hooks/useGetUsersDataAndCriteria.tsx';

export const UsersListPage = () => {
  const { t } = useTranslation();
  const { error, loading, users, criteria, handleCriteriaChange } = useGetUsersDataAndCriteria();

  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'create-user-button',
      href: '/users/create',
      isAllowed: true,
      label: t('Create New User'),
      showAsActionButton: true,
    },
  ];

  if (error) {
    throw new Error('Users Error');
  }

  return (
    <PageHeader
      sticky
      render={() => <HeaderActions actions={actions} />}
      titlePrefix="OpenXSelect"
      title={t('Users List')}
    >
      <UsersList
        criteria={criteria}
        handleCriteriaChange={handleCriteriaChange}
        handleFiltersChange={handleCriteriaChange}
        loading={loading}
        users={loading ? [] : users}
      />
    </PageHeader>
  );
};
